import React, {Component} from 'react';

import LoginForm from '../LoginForm/LoginForm';

class Home extends Component {
	render() {
		return (
			<LoginForm className="login-form" {...this.props} />
		)
	}
}

export default Home;
